import * as React from 'react';
import {Select} from '@sail/ui';

export const Controlled = () => {
  const [selected, setSelected] = React.useState();
  return (
    <Select
      name="demo-001"
      value={selected}
      onChange={(e) => {
        setSelected(e.target.value);
      }}
      label="Choose a pet"
    >
      <option value="">Choose an option</option>
      <option value="dogs">Dogs</option>
      <option value="cats">Cats</option>
    </Select>
  );
};
